import * as React from 'react';
import { styled } from 'styled-components';
import { useRouter } from 'next/router';

import {
  Button,
  Dropdown,
  DropdownOption,
  FormField,
  FormFieldControl,
  FormFieldLabel,
  tk,
  verticalGap,
} from '@sunwebgroup/ui-components';

const Wrapper = styled.div`
  padding: ${tk('spacing_lg')};
  ${verticalGap('spacing_lg')}
`;

export function GenerateSIDButton() {
  const router = useRouter();
  const [scenario, setScenario] = React.useState<string | undefined>('GenerateDraftForReactWorking');

  const handleButtonClick = async () => {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_CHECKOUT_API_BASE_URL}/datagenerator?scenario=${scenario}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.sundiogroup.v1+json',
        },
      }
    );

    const data = await response.text();
    const generatedSid = data.replace(/"/g, '');

    router.replace({
      query: { ...router.query, sid: generatedSid },
    });
  };

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <Wrapper>
      <Button onClick={handleButtonClick}>Generate new sid</Button>
      <FormField>
        <FormFieldLabel>Scenario</FormFieldLabel>
        <FormFieldControl>
          <Dropdown value={scenario} onValueChange={setScenario}>
            <DropdownOption value="GenerateDraftForReactWorking">GenerateDraftForReactWorking</DropdownOption>
            <DropdownOption value="CarRentalNoOpenJawNotIncludedFourParticipants">
              CarRentalNoOpenJawNotIncludedFourParticipants
            </DropdownOption>
          </Dropdown>
        </FormFieldControl>
      </FormField>
    </Wrapper>
  );
}
